import styled from "styled-components";
import * as h from "../../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  position: absolute;
  height: 9.2em;
  bottom: 1em;
  border-radius: 999em;
  width: 2.2em;
  right: -0.15em;
  background: ${h.getBackgroundColor("slider", "slider")};
`;
